export default "__VITE_ASSET__DlyHbMtJ__"